export function buildShareFormUrl(token: string): string {
  if (typeof window === 'undefined') return `/share/form/${token}`;

  return `${window.location.origin}/share/form/${token}`;
}
